import React from 'react';

export default function PageHeader({ icon, title, subtitle, actions }) {
  return (
    <div className="section-header">
      {icon && <span className="section-header-icon" aria-hidden>{icon}</span>}
      <div className="section-header-text">
        {title && <h2>{title}</h2>}
        {subtitle && <p>{subtitle}</p>}
      </div>
      {actions && <div className="section-header-actions">{actions}</div>}
    </div>
  );
}
